export const certificateKinds = [
    {name: 'Сертификат соответствия', code: 'certificate_of_conformity'},
    {name: 'Декларация', code: 'declaration'},
    {name: 'Отказное письмо', code: 'refusal_letter'},
];

export const complianceTypes = [
    {name: 'ГОСТ', code: 'gost'},
    {name: 'Технический регламент ТС', code: 'tr_ts'},
    {name: 'Технический регламент РФ', code: 'tr_rf'},
];

export const ozonCertificateStatuses = [
    {name: 'Одобрен', code: 'approved'},
    {name: 'Ожидает проверки', code: 'awaiting_verification'},
    {name: 'Отклонён', code: 'declined'},
    {name: 'На проверке', code: 'verification'},
];

export const ozonProductStatuses = [
    {name: 'На проверке', code: 'awaiting_verification'},
    {name: 'Одобрен', code: 'approved'},
    {name: 'Отклонён', code: 'declined'},
];

export const ozonUploadStatuses = [
    {name: 'Выгруженные', code: true},
    {name: 'Не выгруженные', code: false},
];

export const ozonSyncTypes = [
    {name: 'Сертификат соответствия', code: 'certificate_of_conformity'},
    {name: 'Декларация', code: 'declaration'},
    {name: 'Отказное письмо', code: 'refused_letter'},
];

const kindLabels = Object.fromEntries(certificateKinds.map(({code, name}) => [code, name]));
const complianceLabels = Object.fromEntries(complianceTypes.map(({code, name}) => [code, name]));
const ozonCertificateStatusLabels = Object.fromEntries(ozonCertificateStatuses.map(({code, name}) => [code, name]));
const ozonProductStatusLabels = Object.fromEntries(ozonProductStatuses.map(({code, name}) => [code, name]));

export function getKindLabel(code) {
    return kindLabels[code] || code || '';
}

export function getComplianceLabel(code) {
    return complianceLabels[code] || code || '';
}

export function getOzonCertificateStatusLabel(code) {
    return ozonCertificateStatusLabels[code] || code || '';
}

export function getOzonProductStatusLabel(code) {
    return ozonProductStatusLabels[code] || code || '';
}

export function formatCertificateDate(dateString) {
    if (!dateString) {
        return '';
    }
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}.${month}.${year}`;
}

export function toDateString(value) {
    if (!value) {
        return null;
    }
    if (typeof value === 'string') {
        return value.split('T')[0];
    }
    const year = value.getFullYear();
    const month = String(value.getMonth() + 1).padStart(2, '0');
    const day = String(value.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
}

export function parseDateForPicker(dateString) {
    if (!dateString) {
        return null;
    }
    const [year, month, day] = dateString.split('T')[0].split('-').map(Number);
    return new Date(year, month - 1, day);
}

export function validateDates(itemData) {
    if (itemData.is_perpetual) {
        if (itemData.valid_until) {
            return 'Для бессрочного сертификата срок действия должен быть пустым';
        }
        return null;
    }
    if (!itemData.valid_until) {
        return 'Укажите срок действия или отметьте «Бессрочный»';
    }
    if (itemData.issue_date && itemData.valid_until < itemData.issue_date) {
        return 'Срок действия не может быть раньше даты выдачи';
    }
    return null;
}

const DEFAULT_ERROR = 'Произошла ошибка. Проверьте данные и попробуйте снова.';

export function parseCertificateError(e) {
    const status = e?.response?.status;
    const data = e?.response?.data;

    if (status === 400) {
        return 'Недопустимый тип файла. Допустимы PDF, JPEG, PNG';
    }
    if (status === 409) {
        return 'Сертификат с таким номером уже существует в компании';
    }
    if (status === 422) {
        if (typeof data?.detail === 'string') {
            return data.detail;
        }
        if (Array.isArray(data?.detail)) {
            return data.detail.map((item) => item.msg || item).join('; ');
        }
        return 'Не удалось извлечь данные из документа / ошибка валидации';
    }
    if (typeof data?.detail === 'string') {
        return data.detail;
    }
    return DEFAULT_ERROR;
}

export function parseOzonError(e) {
    const data = e?.response?.data;

    if (typeof data?.detail === 'string') {
        return data.detail;
    }
    if (Array.isArray(data?.detail)) {
        return data.detail.map((item) => item.msg || item).join('; ');
    }
    return DEFAULT_ERROR;
}

export const ALLOWED_FILE_TYPES = ['application/pdf', 'image/jpeg', 'image/png'];
export const ALLOWED_FILE_EXTENSIONS = ['.pdf', '.jpg', '.jpeg', '.png'];

export function isAllowedCertificateFile(file) {
    if (!file) {
        return false;
    }
    const extension = '.' + file.name.split('.').pop().toLowerCase();
    return ALLOWED_FILE_TYPES.includes(file.type) || ALLOWED_FILE_EXTENSIONS.includes(extension);
}

export function formatTags(tags) {
    if (!tags || !tags.length) {
        return '—';
    }
    return tags.join(', ');
}

export function isCertificateActive(certificate) {
    if (!certificate) {
        return false;
    }
    if (certificate.is_perpetual) {
        return true;
    }
    if (!certificate.valid_until) {
        return false;
    }
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const validUntil = new Date(certificate.valid_until);
    validUntil.setHours(0, 0, 0, 0);
    return validUntil >= today;
}

export function formatProductCertificatesSummary(count, numbers = []) {
    if (!count) {
        return 'Нет';
    }
    if (count === 1) {
        return numbers?.[0] || '1 сертификат';
    }
    return `${count} сертификата`;
}

export const MAX_CERTIFICATE_LINKS = 200;

export const CERTIFICATE_LINKS_DOWNLOAD_TASK = 'certificate_links_download';
export const CERTIFICATE_LINKS_IMPORT_TASK = 'certificate_links_import';
export const CERTIFICATE_COPY_TASK = 'certificate_copy';

const certificateLinksTaskNames = [
    'Загрузка сертификатов по ссылкам',
    'Импорт сертификатов по ссылкам из файла',
    'Копирование сертификатов из другой компании',
];

export function isCertificateLinksTask(task) {
    if (!task) {
        return false;
    }
    const type = task.task_type || task.type;
    if ([CERTIFICATE_LINKS_DOWNLOAD_TASK, CERTIFICATE_LINKS_IMPORT_TASK, CERTIFICATE_COPY_TASK].includes(type)) {
        return true;
    }
    return certificateLinksTaskNames.some((name) => (task.name || '').startsWith(name));
}

// Разбивает текст поля на непустые строки без дублей (бэкенд делает то же самое)
export function splitLinks(text) {
    const seen = new Set();
    return (text || '')
        .split(/\r?\n/)
        .map((line) => line.trim())
        .filter((line) => {
            if (!line || seen.has(line)) {
                return false;
            }
            seen.add(line);
            return true;
        });
}

const linkTypeInfo = {
    file: {label: 'Файл — будет скачан и распознан', color: 'success'},
    fsa_declaration: {label: 'Декларация из реестра ФСА', color: 'success'},
    fsa_certificate: {label: 'Сертификат из реестра ФСА', color: 'success'},
    unknown: {label: 'Попробуем скачать как файл', color: 'warning'},
    registry: {label: null, color: 'secondary'},
    unsupported: {label: null, color: 'secondary'},
};

export function getLinkCheckView(item) {
    const info = linkTypeInfo[item?.type];
    if (!info) {
        return {
            label: item?.reason || (item?.supported ? 'Будет загружено' : 'Не поддерживается'),
            color: item?.supported ? 'success' : 'secondary',
        };
    }
    return {
        label: info.label || item.reason || 'Не поддерживается',
        color: info.color,
    };
}

export function parseRequestError(e, fallback = DEFAULT_ERROR) {
    const detail = e?.response?.data?.detail;
    if (typeof detail === 'string' && detail) {
        return detail;
    }
    if (Array.isArray(detail) && detail.length) {
        return detail.map((item) => item?.msg || String(item)).join('; ');
    }
    return fallback;
}

// Владелец ли пользователь компании. Если бэкенд не отдаёт сведений о роли — считаем, что да,
// а отказ (403) покажем при запуске
export function isCompanyOwner(company, userId) {
    if (!company) {
        return false;
    }
    if (typeof company.is_owner === 'boolean') {
        return company.is_owner;
    }
    if (company.role) {
        return company.role === 'owner';
    }
    if (company.owner_id && userId) {
        return String(company.owner_id) === String(userId);
    }
    return true;
}
